import download from "../utils/download.js";
import { REQUEST_CHAT, RECEIVE_CHAT, UPDATE_CHAT, USE_SUGGESTION, RETURN_TO_CHAT, END_CHAT, REQUEST_SUBMIT_RATING, SAVE_POSITION, RECEIVE_SUBMIT_RATING, SKIP_SUBMIT_RATING, SEND_EVENT, REQUEST_CHAT_TRANSCRIPT, RECEIVE_CHAT_TRANSCRIPT, ENDING_CHAT, REQUEST_UPDATE_CHAT_LOG, RECEIVE_UPDATE_CHAT_LOG, REQUEST_AVERAGE_WAIT_TIME, RECEIVE_AVERAGE_WAIT_TIME, REQUEST_QUEUE_MESSAGES, RECEIVE_QUEUE_MESSAGES, LEAVE_QUEUE, CYCLE_QUEUE_MESSAGE, CYCLE_POSITION_MESSAGE, LEAVING_QUEUE, BACK_TO_QUEUE, GET_CHAT_TRANSCRIPT, UPDATE_CHAT_LOG, GET_AVERAGE_WAIT_TIME, GET_QUEUE_MESSAGES, RATE_CHAT, MYDPD_WELCOME_MESSAGE, RESET_CHAT_STATE, RESET_CONFIG_STATE, RECEIVE_QUEUE_POSITION_MESSAGES, SET_CHAT_STATUS } from "./Constants";
import { initiateChat, sendVisitorMessage } from "./LiveActions";
import { hideChatPanel, closeChat } from "./ChatBarActions";
function requestChat(message) {
  return {
    type: REQUEST_CHAT,
    message
  };
}
function receiveChat(result) {
  return {
    type: RECEIVE_CHAT,
    result
  };
}
export function onLoadChat({
  message,
  parcelCode,
  init = false,
  silentMessage = "",
  apiClient
}) {
  return async (dispatch, getState) => {
    dispatch(requestChat(message));
    const state = getState().chat;
    let result = null;
    result = {
      messages: [!state.chatBot?.alreadyWelcomed ? {
        type: "default",
        message: MYDPD_WELCOME_MESSAGE.replace("{consumerName}", state.config.consumerName)
      } : null],
      suggestions: state.config.initialQuestions
    };
    dispatch(receiveChat(result));
    dispatch(cycleQueueMessage());
  };
}
export function onClickSend({
  message,
  parcelCode,
  silentMessage = "",
  apiClient
}) {
  return async (dispatch, getState) => {
    const dfCaseId = getState().chat?.chatBot?.dfCaseId;
    dispatch(requestChat(message));
    dispatch(cycleQueueMessage());
    if (dfCaseId) {
      dispatch(sendVisitorMessage(message, apiClient));
    } else {
      dispatch(initiateChat(apiClient));
    }
  };
}
export function updateChat(message) {
  return {
    type: UPDATE_CHAT,
    message
  };
}
export function useSuggestion(suggestion) {
  return {
    type: USE_SUGGESTION,
    suggestion
  };
}
export function returnToChat() {
  return {
    type: RETURN_TO_CHAT
  };
}
export function endChat() {
  return {
    type: END_CHAT
  };
}
export function setChatStatus(chatStatus) {
  return {
    type: SET_CHAT_STATUS,
    chatStatus
  };
}
export function endingChat() {
  return {
    type: ENDING_CHAT
  };
}
function requestSubmitRating() {
  return {
    type: REQUEST_SUBMIT_RATING
  };
}
function receiveSubmitRating() {
  return {
    type: RECEIVE_SUBMIT_RATING
  };
}
export function skipSubmitRating() {
  return (dispatch, getState) => {
    dispatch({
      type: SKIP_SUBMIT_RATING
    });
    const state = getState().chat;
    setTimeout(() => {
      dispatch(hideChatPanel());
    }, state.config.timeoutClosure * 1000);
    setTimeout(() => {
      dispatch(closeChat());
    }, state.config.timeoutClosure * 1000 + 1000);
  };
}
export function fetchUpdateRating(rating, notes, apiClient) {
  return async (dispatch, getState) => {
    dispatch(requestSubmitRating());
    const state = getState().chat;
    await apiClient.post(RATE_CHAT, null, null, {
      advisorName: state.chatBot.dfAdvisorName || "N/A",
      rating,
      customerFeedback: notes
    });
    dispatch(receiveSubmitRating());
    setTimeout(() => {
      dispatch(hideChatPanel());
    }, state.config.timeoutClosure * 1000);
    setTimeout(() => {
      dispatch(closeChat());
    }, state.config.timeoutClosure * 1000 + 1000);
  };
}
export function useRichContent(content) {
  const obj = document.getElementById("dpdgroup-chatbot-fmp");
  const event = new CustomEvent("dpd/cbot/fmp-action", {
    detail: content
  });
  obj.dispatchEvent(event);
  return {
    type: SEND_EVENT,
    content
  };
}
function requestTranscript() {
  return {
    type: REQUEST_CHAT_TRANSCRIPT
  };
}
function receiveTranscript() {
  return {
    type: RECEIVE_CHAT_TRANSCRIPT
  };
}
export function fetchTranscript(apiClient) {
  return async (dispatch, getState) => {
    dispatch(requestTranscript());
    const state = getState().chat;
    const transcript = await apiClient.get(GET_CHAT_TRANSCRIPT, {
      parcelCode: state.config.parcelCode
    });
    download("data:application/pdf;base64," + transcript, "transcript.pdf");
    dispatch(receiveTranscript());
  };
}
function requestAverageWaitTime() {
  return {
    type: REQUEST_AVERAGE_WAIT_TIME
  };
}
function receiveAverageWaitTime(waitTime) {
  return {
    type: RECEIVE_AVERAGE_WAIT_TIME,
    waitTime
  };
}
export function fetchAverageWaitTime(apiClient) {
  return async dispatch => {
    dispatch(requestAverageWaitTime());
    let waitTime = null;
    try {
      waitTime = await apiClient.get(GET_AVERAGE_WAIT_TIME);
    } catch (e) {
      throw new Error(e);
    }
    dispatch(receiveAverageWaitTime(waitTime));
  };
}
function requestQueueMessages() {
  return {
    type: REQUEST_QUEUE_MESSAGES
  };
}
export function receiveQueueMessages(queueMessages) {
  return {
    type: RECEIVE_QUEUE_MESSAGES,
    queueMessages
  };
}
export function receiveQueuePositionMessages(queueMessages) {
  return {
    type: RECEIVE_QUEUE_POSITION_MESSAGES,
    queueMessages
  };
}
export function fetchQueueMessasges(apiClient) {
  return async dispatch => {
    dispatch(requestQueueMessages());
    const messages = await apiClient.get(GET_QUEUE_MESSAGES);
    dispatch(receiveQueueMessages(messages));
  };
}
let cycleQueueMessageTimeout = null;
export function cycleQueueMessage() {
  return async (dispatch, getState) => {
    clearTimeout(cycleQueueMessageTimeout);
    const state = getState().chat;
    if (!state.chatBot.messages || !state.chatBot.dfQueue || state.chatBot.dfQueue <= 0) {
      cycleQueueMessageTimeout = setTimeout(() => {
        dispatch(cycleQueueMessage());
      }, 1000);
      return;
    }
    const newMessage = getNextEducationalMessage(state.chatBot.queueMessage, state.chatBot.messages);
    const type = "educational";
    dispatch({
      type: CYCLE_QUEUE_MESSAGE,
      message: {
        id: newMessage.id,
        title: newMessage.message.split(";")[0],
        body: newMessage.message.split(";")[1],
        type,
        waitTime: 40
      }
    });
    cycleQueueMessageTimeout = setTimeout(() => {
      dispatch(cycleQueueMessage());
    }, 40 * 1000);
  };
}
export function cyclePositionMessage() {
  return async (dispatch, getState) => {
    const {
      dfQueue,
      messages
    } = getState().chat.chatBot;
    const newMessage = getQueueMessageForPosition(dfQueue, messages?.queueMessages);
    newMessage && dispatch({
      type: CYCLE_POSITION_MESSAGE,
      message: {
        id: newMessage.id,
        title: newMessage.message.split(";")[0],
        body: newMessage.message.split(";")[1]
      }
    });
  };
}
function getQueueMessageForPosition(position = 1, messages = []) {
  let currentMessage = null;
  let maxMessage = messages[0];
  messages.forEach(message => {
    const roundedMessage = Math.ceil(position / 10) * 10;
    if (parseInt(message.queuePosition, 10) > parseInt(maxMessage.queuePosition, 10)) {
      maxMessage = message;
    }
    if (parseInt(message.queuePosition, 10) === roundedMessage) {
      currentMessage = message;
    }
  });
  if (!currentMessage) {
    currentMessage = maxMessage;
  }
  return currentMessage;
}
function getNextEducationalMessage(current, messages) {
  // if there is no current message, pick the one with the lowest id
  if (!current) {
    let minMessage = messages[0];
    for (let i = 0; i < messages.length; i++) {
      if (messages[i].id < minMessage.id) {
        minMessage = messages[i];
      }
    }
    return minMessage;
  }

  // otherwise, get the next id
  let newMessage = messages[0];
  for (let i = 0; i < messages.length; i++) {
    if (!current || messages[i].id > current.id && (messages[i].id < newMessage.id || newMessage.id === messages[0].id)) {
      newMessage = messages[i];
    }
  }
  return newMessage;
}
export function leaveQueue() {
  return {
    type: LEAVE_QUEUE
  };
}
export function savePosition(bottom, right) {
  return {
    type: SAVE_POSITION,
    bottom,
    right
  };
}
export function leavingQueue() {
  return {
    type: LEAVING_QUEUE
  };
}
export function backToQueue() {
  return {
    type: BACK_TO_QUEUE
  };
}
export function resetChatState() {
  return {
    type: RESET_CHAT_STATE
  };
}
export function resetConfigState() {
  return {
    type: RESET_CONFIG_STATE
  };
}